/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Search_FdcInputs */

const en_fix_search_fdc = /** @type {(inputs: Fix_Search_FdcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search USDA foods (English)`)
};

const de_fix_search_fdc = /** @type {(inputs: Fix_Search_FdcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USDA-Lebensmittel suchen (Englisch)`)
};

/**
* | output |
* | --- |
* | "Search USDA foods (English)" |
*
* @param {Fix_Search_FdcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_search_fdc = /** @type {((inputs?: Fix_Search_FdcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Search_FdcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_search_fdc(inputs)
	return en_fix_search_fdc(inputs)
});